const GLOSSARY_TERM_PATTERN = /^[\p{L}\p{N}\s\-"'.,!?¿¡:;\/()\[\]{}<>\u2010\u2011\u2012\u2013\u2014\u2015\u2018\u2019\u201A\u201B\u201C\u201D\u201E\u201F\u2039\u203A«»…]+$/u;

export const isValidGlossaryTerm = (input: string): boolean =>
  GLOSSARY_TERM_PATTERN.test(input.trim());
